import React, { Component, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import {getAvailabilityObjetive} from '../../../../../../services/getAvailability'
import { intlFormat } from 'date-fns';

class AvailibilityGlobalObjetive extends Component {

    constructor(props) {
        //console.log('props destino', props)
        super(props);
        this.state = {
            objective:props.data.data,
            Availability:{},
            isLoading:true,
            user:sessionStorage.getItem("user"),
            token:sessionStorage.getItem("key"),

        }
    }
    
    componentDidMount() {
        this.processData();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.isLoading===true){
            this.processData();
        }
    }
    // Helper para procesar la data de la petición a la API
    
    processData = () => {
        const {user, token, objective}=this.state
        if(objective.estado==="No monitoreo"){
            this.setState({
                Availability:"Sin Datos",
                isLoading:false
            })
        }else{
            getAvailabilityObjetive(this.state.objective.objetivo_id, "h",user, token ).then(data => {
                var availability=data.data.uptime+data.data.parcial+data.data['evento_cliente']
                if (typeof(availability) == 'number' && availability % 1 != 0){
                    availability = availability.toFixed(2)
                }
                this.setState({
                    Availability:String(availability)+"%",
                    isLoading:false
                })
            })
        }
        setInterval(() => this.componentDidMount(),900000);
        
    }
    
    render() {
        const {  isLoading, Availability } = this.state;
        
        if (isLoading===true) {
            return(
                <PortletContent >
    
                        <Typography
                          variant="h5"
                          style={{color:"white"}}
                          align="center"
                        >
                         <CircularProgress
                          variant="indeterminate"
    
                          size={24}
                          thickness={4}
                          
                        />
                        <br/>
                         Cargando Información...
                       </Typography>
                </PortletContent>
            )
        }else if(isLoading===false){
            return(
                <Grid item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                >
                    <Typography
                          variant="h3"
                          style={{color:"white", fontSize: "54px"}}
                        >{Availability}
                    </Typography>
                </Grid>
            )
        }

    }
}



export default withRouter(AvailibilityGlobalObjetive);